import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import moment from "moment";
import appUrl from "../../../../config/appUrl";

const DashboardCollectionReport = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const fromDate = queryParams.get("fromDate");
  const toDate = queryParams.get("toDate");
  const site = queryParams.get("site");

  const [dashList, setDashList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalFee, setTotalFee] = useState(0);

  // Fetch data function
  const getDashData = async (page = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}parkingHistory/getCollectionData?fromDate=${fromDate}&toDate=${toDate}&site=${site || ""}&page=${page}&pageSize=${pageSize}&excelExport=false`
      );
      const result = await response.json();

      const allData = result?.data?.data || [];
      const totalCollection = result?.data?.totalCollection || 0;
      const totalRecordsFromApi = result?.data?.totalRecords || 0;

      const mappedData = allData.map(item => ({
        _id: item._id,
        vehicleRegNumber: item?.vehicleRegNumber || "-",
        vehicleType: item?.vehicleType?.name || "-",
        site: item?.site?.site || "-",
        checkInBy: item?.checkInBy?.boothId?.name || "-",
        checkOutBy: item?.checkOutBy?.boothId?.name || "-",
        checkInTime: item?.checkInTime || null,
        checkOutTime: item?.checkOutTime || null,
        parkingFee: item?.parkingFee || 0,
        parkedTime: item?.parkedTime || 0,
      }));

      setDashList(mappedData);
      setTotalFee(totalCollection);
      setTotalRecords(totalRecordsFromApi);
    } catch (error) {
      console.error("Error fetching report:", error);
      setDashList([]);
      setTotalFee(0);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashData(currentPage, currentPageSize);
  }, [fromDate, toDate, site]);

  const formatParkedTime = (minutes) => {
    if (!minutes && minutes !== 0) return "-";
    return `${minutes} min`;
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Total:" colSpan={8} footerStyle={{ textAlign: "right" }} />
        <Column
          footer={new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR" }).format(totalFee || 0)}
        />
      </Row>
    </ColumnGroup>
  );

  const handlePageChange = (event) => {
    const newPage = event.page + 1;
    const newPageSize = event.rows;
    setCurrentPage(newPage);
    setCurrentPageSize(newPageSize);
    getDashData(newPage, newPageSize);
  };

  return (
    <div className="p-4">
      <h2>Collection Report</h2>
      {loading ? (
        <h3>Loading...</h3>
      ) : (
        <DataTable
          value={dashList}
          footerColumnGroup={footerGroup}
          paginator
          rows={currentPageSize}
          totalRecords={totalRecords}
          first={(currentPage - 1) * currentPageSize}
          onPage={handlePageChange}
          loading={loading}
          lazy
          scrollable
          emptyMessage="No records found"
        >
          <Column
            header="ID"
            body={(rowData) => (
              <div title={rowData._id} style={{ cursor: "pointer" }}>
                {`${rowData._id?.slice(0, 6)}...${rowData._id?.slice(-6)}`}
              </div>
            )}
          />
          <Column field="site" header="Site Name" />
          <Column field="vehicleType" header="Vehicle" />
          <Column field="vehicleRegNumber" header="Registration" />
          <Column
            field="checkInTime"
            header="Check-In"
            body={(rowData) =>
              rowData.checkInTime ? moment.utc(rowData.checkInTime).format("hh:mm:ss A YYYY-MM-DD") : "-"
            }
          />
          <Column field="checkInBy" header="Check-In Booth" />
          <Column
            field="checkOutTime"
            header="Check-Out"
            body={(rowData) =>
              rowData.checkOutTime ? moment.utc(rowData.checkOutTime).format("hh:mm:ss A YYYY-MM-DD") : "-"
            }
          />
          <Column field="checkOutBy" header="Check-Out Booth" />
          <Column
            field="parkingFee"
            header="Parking Fee"
            body={(rowData) =>
              new Intl.NumberFormat("en-PK", { style: "currency", currency: "PKR" }).format(rowData.parkingFee)
            }
          />
          <Column
            field="parkedTime"
            header="Park Time"
            body={(rowData) => formatParkedTime(rowData.parkedTime)}
          />
        </DataTable>
      )}
    </div>
  );
};

export default DashboardCollectionReport;
